@if (currentNotification; as notification) {
<div class="notifications-content">
  <div class="notification-header">
    <h3>{{ notification.title }}</h3>
    @if (currentNotificationDate) {
    <span>{{ currentNotificationDate }}</span>
    }
  </div>
  <div class="notification-content" [innerHTML]="notification.content"></div>
  @if (notification.link && notification.linkLabel) {
  <a class="en-savoir-plus" [href]="notification.link" target="_blank" rel="noopener noreferrer">
    {{ notification.linkLabel }}
  </a>
  }
  <p class="notification-read">
    <span class="material-icons-outlined notification-read-icon">done</span>
    <span>{{ 'common.read_at' | translate : { date: readAtDate, time: readAtTime } }}</span>
  </p>
</div>
}

<div class="actions">
  <p class="notification-counter">{{ currentIndex + 1 }} / {{ notifications.length }}</p>
  <lib-button
    [text]="(isLastNotification ? 'form.buttons.close' : 'form.buttons.next') | translate"
    borderColor="primary-dark"
    backgroundColor="primary-dark"
    color="white"
    [disabled]="submitting"
    (onClick)="confirm()"
  />
</div>
